(function () {
  'use strict';

  function setActiveNavLink() {
    var links = document.querySelectorAll('.vu-header__nav-link');
    var path = window.location.pathname;
    links.forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href === '#' || href.charAt(0) === '#') return;
      try {
        var u = new URL(href, window.location.origin);
        if (u.pathname === path) link.classList.add('is-active');
      } catch (e) {
        if (href === path) link.classList.add('is-active');
      }
    });
  }

  function initMobileMenu() {
    var toggle = document.querySelector('[data-vu-menu-toggle]');
    var menu = document.querySelector('[data-vu-menu]');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  function initProductThumbs() {
    var featured = document.getElementById('VuProductFeaturedImg');
    if (!featured) return;
    document.querySelectorAll('[data-vu-product-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-src');
        var alt = btn.getAttribute('data-alt') || '';
        if (src) {
          featured.src = src;
          featured.alt = alt;
        }
        document.querySelectorAll('[data-vu-product-thumb]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });
  }

  function initVariantSelect() {
    var jsonEl = document.getElementById('VuProductVariants');
    if (!jsonEl) return;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var variantInput = document.querySelector('[data-vu-variant-id]');
    var priceEl = document.querySelector('[data-vu-price]');
    var compareEl = document.querySelector('[data-vu-compare]');
    var subtitleEl = document.querySelector('[data-vu-variant-subtitle]');
    var featured = document.getElementById('VuProductFeaturedImg');
    var addBtn = document.querySelector('[data-vu-add-to-cart]');
    var optionButtons = document.querySelectorAll('[data-vu-option]');

    if (!variantInput || !variants.length) return;

    function getSelectedOptions() {
      var options = [];
      var fieldsets = document.querySelectorAll('[data-vu-option-fieldset]');
      fieldsets.forEach(function (fieldset) {
        var index = parseInt(fieldset.getAttribute('data-vu-option-fieldset'), 10);
        var active = fieldset.querySelector('[data-vu-option].is-active');
        options[index] = active ? active.getAttribute('data-value') : null;
      });
      return options;
    }

    function findVariant() {
      var selected = getSelectedOptions();
      return variants.find(function (variant) {
        return variant.options.every(function (opt, i) {
          return !selected[i] || opt === selected[i];
        });
      });
    }

    function syncVariant(variant) {
      if (!variant) return;

      variantInput.value = variant.id;

      if (priceEl) priceEl.textContent = variant.price_money || '';
      if (compareEl) {
        if (variant.compare_money) {
          compareEl.textContent = variant.compare_money;
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.textContent = '';
          compareEl.setAttribute('hidden', '');
        }
      }

      if (subtitleEl && variant.title && variant.title !== 'Default Title') {
        subtitleEl.textContent = variant.title;
      }

      if (featured && variant.featured_image && variant.featured_image.src) {
        featured.src = variant.featured_image.src;
        featured.alt = variant.featured_image.alt || '';
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? addBtn.getAttribute('data-label-available') || 'Add to Cart'
          : addBtn.getAttribute('data-label-sold-out') || 'Sold out';
      }

      var customizer = document.getElementById('customizer');
      if (customizer) customizer.setAttribute('data-variant', variant.id);
    }

    if (addBtn) {
      addBtn.setAttribute('data-label-available', addBtn.textContent.trim());
      addBtn.setAttribute('data-label-sold-out', 'Sold out');
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var fieldset = btn.closest('[data-vu-option-fieldset]');
        if (!fieldset) return;

        fieldset.querySelectorAll('[data-vu-option]').forEach(function (optionBtn) {
          var active = optionBtn === btn;
          optionBtn.classList.toggle('is-active', active);
          optionBtn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        syncVariant(findVariant());
      });
    });

    syncVariant(findVariant());
  }

  function initProductQuantity() {
    var input = document.querySelector('[data-vu-qty]');
    if (!input) return;

    var minus = document.querySelector('[data-vu-qty-minus]');
    var plus = document.querySelector('[data-vu-qty-plus]');

    function step(delta) {
      var value = parseInt(input.value, 10) || 1;
      value = Math.max(1, value + delta);
      input.value = String(value);
    }

    if (minus) minus.addEventListener('click', function () { step(-1); });
    if (plus) plus.addEventListener('click', function () { step(1); });
  }

  function initProductCustomize() {
    var btn = document.querySelector('[data-vu-open-customizer]');
    var openBtn = document.getElementById('open-customizer-button');
    if (!btn || !openBtn) return;

    btn.addEventListener('click', function () {
      openBtn.click();
    });
  }

  function initSkipLink() {
    var skip = document.querySelector('.skip-to-content-link');
    if (!skip) return;
    skip.addEventListener('click', function (e) {
      var target = document.querySelector(skip.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function updateCartCount(count) {
    var badge = document.querySelector('[data-vu-cart-count]');
    var link = document.querySelector('[data-vu-cart-link]');
    if (!badge) return;

    if (count > 0) {
      badge.textContent = String(count);
      badge.hidden = false;
      if (link) link.setAttribute('aria-label', 'Cart (' + count + ')');
    } else {
      badge.hidden = true;
      if (link) link.setAttribute('aria-label', 'Cart');
    }
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (res) {
        if (!res.ok) throw new Error('cart fetch failed');
        return res.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count || 0);
      })
      .catch(function () {
        /* ignore */
      });
  }

  function initCartRecipeThumbnails() {
    var images = document.querySelectorAll('[data-vu-recipe-id]');
    if (!images.length) return;

    var cache = {};

    function revealRecipeImage(img, src) {
      if (!src) {
        src = img.getAttribute('data-vu-fallback-src');
        if (!src) return;
      }

      var preload = new Image();
      preload.onload = function () {
        img.src = src;
        img.classList.add('is-loaded');
      };
      preload.onerror = function () {
        var fallback = img.getAttribute('data-vu-fallback-src');
        if (fallback && fallback !== src) {
          revealRecipeImage(img, fallback);
          return;
        }
        img.classList.add('is-loaded');
      };
      preload.src = src;
    }

    function applyThumbnail(id, thumbnail) {
      images.forEach(function (el) {
        if (el.getAttribute('data-vu-recipe-id') === id) revealRecipeImage(el, thumbnail);
      });
    }

    function fetchRecipeThumbnail(id) {
      if (Object.prototype.hasOwnProperty.call(cache, id)) {
        return Promise.resolve(cache[id]);
      }

      cache[id] = fetch('https://os.vucustom.com/api/recipes/' + encodeURIComponent(id))
        .then(function (res) {
          if (!res.ok) throw new Error('recipe fetch failed');
          return res.json();
        })
        .then(function (payload) {
          var thumbnail =
            payload && payload.data && payload.data.images && payload.data.images.thumbnail;
          cache[id] = thumbnail || null;
          return cache[id];
        })
        .catch(function () {
          cache[id] = null;
          return null;
        });

      return cache[id];
    }

    var seen = {};
    images.forEach(function (img) {
      var id = img.getAttribute('data-vu-recipe-id');
      if (!id || seen[id]) return;
      seen[id] = true;
      fetchRecipeThumbnail(id).then(function (thumbnail) {
        if (thumbnail) {
          applyThumbnail(id, thumbnail);
          return;
        }
        applyThumbnail(
          id,
          'https://os.vucustom.com/api/recipes/' + encodeURIComponent(id) + '/images/thumbnail.png'
        );
      });
    });
  }

  function initCartCount() {
    if (!document.querySelector('[data-vu-cart-count]')) return;

    var cartPaths = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
    var nativeFetch = window.fetch;

    window.fetch = function (input, init) {
      return nativeFetch.call(this, input, init).then(function (response) {
        var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
        if (url && cartPaths.some(function (path) { return url.indexOf(path) !== -1; })) {
          refreshCartCount();
        }
        return response;
      });
    };

    document.addEventListener('cart:refresh', refreshCartCount);
    window.addEventListener('pageshow', refreshCartCount);
  }

  function vuCapSection() {
    return document.querySelector('[data-vu-cap-section]');
  }

  /** Product tags may use spaces or hyphens in category/value slugs — compare canonically. */
  function normalizeCapTag(tag) {
    return (tag || '')
      .toLowerCase()
      .trim()
      .replace(/_/g, ' ')
      .replace(/-/g, ' ')
      .replace(/\s+/g, ' ');
  }

  function capTagsMatch(selected, cardTag) {
    return normalizeCapTag(selected) === normalizeCapTag(cardTag);
  }

  function getCapGroupSelections(root) {
    var m = {};
    if (!root) return m;
    root.querySelectorAll('[data-vu-cap-filter]:checked').forEach(function (cb) {
      var g = cb.getAttribute('data-cap-group');
      if (!g) return;
      if (!m[g]) m[g] = [];
      m[g].push(cb.value.toLowerCase().trim());
    });
    return m;
  }

  function capCardMatches(card, groupSelections, searchQuery) {
    var searchText = (card.getAttribute('data-search-text') || '').toLowerCase();
    if (searchQuery && searchText.indexOf(searchQuery) === -1) return false;

    var raw = card.getAttribute('data-cap-tags') || '';
    var tags = raw
      .toLowerCase()
      .split(',')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);

    var groupKeys = Object.keys(groupSelections);
    for (var i = 0; i < groupKeys.length; i++) {
      var g = groupKeys[i];
      var selected = groupSelections[g];
      if (!selected || selected.length === 0) continue;
      var ok = false;
      for (var j = 0; j < selected.length; j++) {
        for (var k = 0; k < tags.length; k++) {
          if (capTagsMatch(selected[j], tags[k])) {
            ok = true;
            break;
          }
        }
        if (ok) break;
      }
      if (!ok) return false;
    }
    return true;
  }

  function buildCapPageList(current, total) {
    if (total <= 9) {
      var simple = [];
      for (var i = 1; i <= total; i++) simple.push(i);
      return simple;
    }
    var pages = {};
    var orderedNums = [];
    function add(n) {
      if (n < 1 || n > total || pages[n]) return;
      pages[n] = true;
      orderedNums.push(n);
    }
    add(1);
    add(total);
    for (var d = -2; d <= 2; d++) add(current + d);
    orderedNums.sort(function (a, b) {
      return a - b;
    });
    var out = [];
    for (var i = 0; i < orderedNums.length; i++) {
      if (i > 0 && orderedNums[i] - orderedNums[i - 1] > 1) out.push('…');
      out.push(orderedNums[i]);
    }
    return out;
  }

  function syncCapabilitiesPagination(opts) {
    opts = opts || {};
    var section = vuCapSection();
    var nav = section ? section.querySelector('[data-vu-cap-pagination]') : null;
    if (!section || !nav) return;

    var perPage = parseInt(section.getAttribute('data-cards-per-page'), 10);
    if (!perPage || perPage < 1) perPage = 12;

    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-vu-cap-card]'));
    var visible = cards.filter(function (c) {
      return !c.classList.contains('vu-cap__card--hidden');
    });

    cards.forEach(function (c) {
      if (c.classList.contains('vu-cap__card--hidden')) {
        c.classList.remove('vu-cap__card--off-page');
      }
    });

    var totalPages = Math.max(1, Math.ceil(visible.length / perPage));
    var current = parseInt(nav.getAttribute('data-current-page'), 10) || 1;
    if (opts.resetPage) current = 1;
    if (opts.goToPage != null) current = opts.goToPage;
    current = Math.min(Math.max(1, current), totalPages);
    nav.setAttribute('data-current-page', String(current));

    visible.forEach(function (card, i) {
      var page = Math.floor(i / perPage) + 1;
      card.classList.toggle('vu-cap__card--off-page', page !== current);
    });

    if (opts.scroll && typeof section.scrollIntoView === 'function') {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (totalPages <= 1) {
      nav.innerHTML = '';
      nav.setAttribute('hidden', '');
      return;
    }

    nav.removeAttribute('hidden');

    function addButton(cls, label, disabled, ariaCurrent, onClick) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = cls;
      b.textContent = label;
      b.disabled = !!disabled;
      if (ariaCurrent) b.setAttribute('aria-current', 'page');
      if (onClick) {
        b.addEventListener('click', function () {
          onClick();
        });
      }
      nav.appendChild(b);
    }

    nav.innerHTML = '';

    addButton('vu-cap__page vu-cap__pagination-prev', 'Previous', current === 1, false, function () {
      syncCapabilitiesPagination({ goToPage: current - 1, scroll: true });
    });

    var pageList = buildCapPageList(current, totalPages);
    for (var k = 0; k < pageList.length; k++) {
      var item = pageList[k];
      if (item === '…') {
        var ell = document.createElement('span');
        ell.className = 'vu-cap__ellipsis';
        ell.textContent = '…';
        ell.setAttribute('aria-hidden', 'true');
        nav.appendChild(ell);
      } else {
        (function (pageNum) {
          var isCur = pageNum === current;
          addButton(
            'vu-cap__page' + (isCur ? ' is-current' : ''),
            String(pageNum),
            false,
            isCur,
            function () {
              syncCapabilitiesPagination({ goToPage: pageNum, scroll: true });
            }
          );
        })(item);
      }
    }

    addButton('vu-cap__page vu-cap__pagination-next', 'Next', current === totalPages, false, function () {
      syncCapabilitiesPagination({ goToPage: current + 1, scroll: true });
    });
  }

  function syncActiveFilterTags() {
    var section = vuCapSection();
    var bar = section ? section.querySelector('[data-vu-cap-active-tags]') : null;
    var list = bar ? bar.querySelector('[data-vu-cap-active-tags-list]') : null;
    if (!bar || !list) return;

    list.innerHTML = '';
    var checked = section.querySelectorAll('[data-vu-cap-filter]:checked');
    if (checked.length === 0) {
      bar.setAttribute('hidden', '');
      return;
    }

    bar.removeAttribute('hidden');
    checked.forEach(function (cb) {
      var group = cb.getAttribute('data-cap-group') || '';
      var labelEl = cb.parentElement
        ? cb.parentElement.querySelector('.vu-cap__filter-label-text')
        : null;
      var valLabel = labelEl ? labelEl.textContent.trim() : cb.value;
      var groupWrap = section.querySelector('[data-cap-filter-group="' + group + '"]');
      var heading = groupWrap ? groupWrap.querySelector('.vu-cap__filter-heading') : null;
      var catLabel = heading ? heading.textContent.trim() : group;

      var pill = document.createElement('span');
      pill.className = 'vu-cap__tag';
      pill.textContent = catLabel + ': ' + valLabel;
      pill.title = cb.value;

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'vu-cap__tag-remove';
      removeBtn.setAttribute('aria-label', 'Remove filter ' + pill.textContent);
      removeBtn.innerHTML = '&times;';
      removeBtn.addEventListener('click', function () {
        cb.checked = false;
        applyCapabilitiesFilters();
      });

      var wrap = document.createElement('span');
      wrap.className = 'vu-cap__active-tag';
      wrap.appendChild(pill);
      wrap.appendChild(removeBtn);
      list.appendChild(wrap);
    });
  }

  function applyCapabilitiesFilters() {
    var section = vuCapSection();
    if (!section) return;
    var input = section.querySelector('[data-vu-cap-search]');
    var q = input ? input.value.trim().toLowerCase() : '';
    var groups = getCapGroupSelections(section);
    var cards = section.querySelectorAll('[data-vu-cap-card]');
    var vis = 0;
    cards.forEach(function (card) {
      var ok = capCardMatches(card, groups, q);
      card.classList.toggle('vu-cap__card--hidden', !ok);
      if (ok) vis++;
    });
    var num = section.querySelector('[data-vu-cap-count-num]');
    if (num) num.textContent = String(vis);

    syncActiveFilterTags();

    var noResultsEl = section.querySelector('[data-vu-cap-no-results]');
    if (noResultsEl) {
      var hasActiveFilters = q.length > 0 || Object.keys(groups).length > 0;
      var hasCards = cards.length > 0;
      noResultsEl.hidden = !(vis === 0 && hasActiveFilters && hasCards);
    }

    syncCapabilitiesPagination({ resetPage: true });
  }

  function clearCapabilitiesQueryParams() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('cap')) return;
      url.searchParams.delete('cap');
      var next = url.pathname + url.search + url.hash;
      window.history.replaceState({}, '', next);
    } catch (e) {
      /* ignore */
    }
  }

  function clearCapabilitiesFilters() {
    var section = vuCapSection();
    if (!section) return;
    section.querySelectorAll('[data-vu-cap-filter]:checked').forEach(function (cb) {
      cb.checked = false;
    });
    var input = section.querySelector('[data-vu-cap-search]');
    if (input) input.value = '';
    clearCapabilitiesQueryParams();
    applyCapabilitiesFilters();
  }

  function initCapabilitiesFilters() {
    var section = vuCapSection();
    if (!section) return;
    var input = section.querySelector('[data-vu-cap-search]');
    if (input) input.addEventListener('input', applyCapabilitiesFilters);
    section.querySelectorAll('[data-vu-cap-filter]').forEach(function (cb) {
      cb.addEventListener('change', applyCapabilitiesFilters);
    });
    var clearBtn = section.querySelector('[data-vu-cap-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        clearCapabilitiesFilters();
      });
    }
  }

  function parseCapQueryTags() {
    var params = new URLSearchParams(window.location.search);
    var caps = params.getAll('cap');
    if (caps.length === 1 && caps[0].indexOf(',') !== -1) {
      caps = caps[0].split(',').map(function (s) {
        return s.trim();
      });
    }
    return caps.map(normalizeCapTag).filter(Boolean);
  }

  /** Pre-check Demos filters from ?cap=vu-cap:category:value (repeat or comma-separated). */
  function initCapabilitiesFromQuery() {
    var section = vuCapSection();
    if (!section) return;
    var wanted = parseCapQueryTags();
    if (!wanted.length) return;
    var applied = false;
    section.querySelectorAll('[data-vu-cap-filter]').forEach(function (cb) {
      var v = normalizeCapTag(cb.value);
      for (var i = 0; i < wanted.length; i++) {
        if (capTagsMatch(wanted[i], v)) {
          cb.checked = true;
          applied = true;
          break;
        }
      }
    });
    if (applied && typeof section.scrollIntoView === 'function') {
      requestAnimationFrame(function () {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCartRecipeThumbnails();
    setActiveNavLink();
    initMobileMenu();
    initProductThumbs();
    initVariantSelect();
    initProductQuantity();
    initProductCustomize();
    initSkipLink();
    initCartCount();
    initCapabilitiesFromQuery();
    initCapabilitiesFilters();
    applyCapabilitiesFilters();
  });
})();
